// // src/components/BoardPack/FinalizeRequestsPanel.jsx
// // Recent background finalize / export requests, latest one per board pack
// // (Finalized BoardPacks page, Board Pack page without filters, Requests
// // dialog). Polls while any request is still queued or generating; ready
// // exports can be downloaded from here.
// import { useEffect, useRef, useState } from "react";
// import { CheckCircle2, Clock, Download, Loader2, XCircle } from "lucide-react";
// import { apiCall } from "@/api/apiCall";
// import { Button } from "@/components/ui/button";
// import { Progress } from "@/components/ui/progress";
// import { toast } from "sonner";
// import { useRecentJobs } from "@/hooks/useRecentJobs";
// import {
//   FINISHED_STATUSES,
//   JOB_STATUS_LABELS,
//   JOB_TYPE_LABELS,
//   downloadJobFile,
// } from "@/lib/reportJobs";
// import { USER_ID } from "@/constants/constant";

// const STATUS_STYLES = {
//   queued: "bg-muted text-muted-foreground",
//   processing: "bg-blue-50 text-blue-600",
//   done: "bg-green-50 text-green-700",
//   failed: "bg-red-50 text-red-600",
//   cancelled: "bg-muted text-muted-foreground",
// };

// const StatusIcon = ({ status }) => {
//   if (status === "processing") return <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />;
//   if (status === "done") return <CheckCircle2 className="w-4 h-4 text-green-600" />;
//   if (status === "failed") return <XCircle className="w-4 h-4 text-red-600" />;
//   return <Clock className="w-4 h-4 text-muted-foreground" />;
// };

// const formatWhen = (iso) => {
//   if (!iso) return "";
//   const date = new Date(iso);
//   return Number.isNaN(date.getTime()) ? iso : date.toLocaleString();
// };

// const statusLabel = (job) => {
//   if (job.status === "processing") return `Generating ${job.progress || 0}%`;
//   if (job.status !== "done") return JOB_STATUS_LABELS[job.status] || job.status;
//   if (job.job_type !== "export") return "Finalized";
//   return job.has_pdf || job.has_pptx ? "Ready to download" : "Replaced";
// };

// const FinalizeRequestsPanel = ({
//   onJobFinished,
//   title = "Finalize & export requests",
//   emptyText = null, // shown instead of hiding the panel when there are no requests
//   className = "mb-6",
// }) => {
//   const { jobs, loaded, reload } = useRecentJobs();
//   const [cancellingId, setCancellingId] = useState(null);
//   const [downloading, setDownloading] = useState(null);
//   const statusRef = useRef({});
//   const onJobFinishedRef = useRef(onJobFinished);
//   useEffect(() => {
//     onJobFinishedRef.current = onJobFinished;
//   }, [onJobFinished]);

//   // A request that just finished means a new file in the lists around us
//   useEffect(() => {
//     const justFinished = jobs.some(
//       (job) =>
//         FINISHED_STATUSES.includes(job.status) &&
//         statusRef.current[job.id] &&
//         !FINISHED_STATUSES.includes(statusRef.current[job.id])
//     );
//     jobs.forEach((job) => {
//       statusRef.current[job.id] = job.status;
//     });
//     if (justFinished) onJobFinishedRef.current?.();
//   }, [jobs]);

//   const cancel = async (id) => {
//     setCancellingId(id);
//     try {
//       await apiCall("post", "/reports/jobs/cancel", { id });
//       await reload();
//     } catch {
//       /* toast already shown */
//     } finally {
//       setCancellingId(null);
//     }
//   };

//   const download = async (job, type) => {
//     setDownloading(`${job.id}-${type}`);
//     try {
//       await downloadJobFile(job, type);
//     } catch {
//       toast.error("Download failed — please export again");
//     } finally {
//       setDownloading(null);
//     }
//   };

//   if (jobs.length === 0) {
//     if (!emptyText || !loaded) return null;
//     return <p className="text-sm text-muted-foreground py-6 text-center">{emptyText}</p>;
//   }

//   return (
//     <div className={`${className} rounded-xl border border-border bg-background`}>
//       <div className="px-4 py-3 border-b">
//         <h2 className="text-sm font-medium text-foreground">{title}</h2>
//         <p className="text-xs text-muted-foreground mt-0.5">
//           Board packs are generated on the server — you can close this page while they run.
//         </p>
//       </div>
//     <div className="divide-y">
//   {jobs.map((job) => {
//     const myId = USER_ID();
//     const isOwner =
//       myId != null &&
//       job.requested_by != null &&
//       String(job.requested_by) === String(myId);
//     const canCancel =
//       isOwner && (job.status === "queued" || job.status === "processing");

//     return (
//       <div key={job.id} className="flex flex-wrap items-center gap-3 px-4 py-3">
//         <StatusIcon status={job.status} />
//         <div className="flex-1 min-w-[200px]">
//           <p className="text-sm font-medium text-foreground truncate">
//             <span className="text-muted-foreground font-normal">
//               {JOB_TYPE_LABELS[job.job_type] || "Finalize"} ·{" "}
//             </span>
//             {job.contract} — {job.month} {job.year}
//           </p>
//           <p className="text-xs text-muted-foreground truncate">
//             {job.requested_by_name ? `${job.requested_by_name} · ` : ""}
//             {formatWhen(job.created_at)}
//             {job.status === "failed" && job.message ? ` · ${job.message}` : ""}
//             {job.status === "processing" && job.message ? ` · ${job.message}` : ""}
//           </p>
//           {job.status === "processing" && (
//             <Progress value={job.progress || 0} className="h-1.5 mt-2 max-w-sm" />
//           )}
//         </div>
//         <span
//           className={`text-xs font-medium px-2 py-0.5 rounded-full ${STATUS_STYLES[job.status] || ""}`}
//         >
//           {statusLabel(job)}
//         </span>
//         {job.job_type === "export" &&
//           job.status === "done" &&
//           [
//             ["pdf", "PDF", job.has_pdf],
//             ["pptx", "PPTX", job.has_pptx],
//           ]
//             .filter(([, , available]) => available)
//             .map(([type, label]) => (
//               <Button
//                 key={type}
//                 variant="outline"
//                 size="sm"
//                 disabled={downloading === `${job.id}-${type}`}
//                 onClick={() => download(job, type)}
//               >
//                 {downloading === `${job.id}-${type}` ? (
//                   <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" />
//                 ) : (
//                   <Download className="w-3.5 h-3.5 mr-1.5" />
//                 )}
//                 {label}
//               </Button>
//             ))}

//         {canCancel && (
//           <Button
//             variant="outline"
//             size="sm"
//             disabled={cancellingId === job.id}
//             onClick={() => cancel(job.id)}
//           >
//             Cancel
//           </Button>
//         )}
//       </div>
//     );
//   })}
// </div>
//     </div>
//   );
// };

// export default FinalizeRequestsPanel;



// // src/components/BoardPack/FinalizeRequestsPanel.jsx
// import { useEffect, useRef, useState } from "react";
// import { CheckCircle2, Clock, Download, Loader2, XCircle } from "lucide-react";
// import { apiCall } from "@/api/apiCall";
// import { Button } from "@/components/ui/button";
// import { Progress } from "@/components/ui/progress";
// import { Skeleton } from "@/components/ui/skeleton";
// import { toast } from "sonner";
// import { useRecentJobs } from "@/hooks/useRecentJobs";
// import {
//   FINISHED_STATUSES,
//   JOB_STATUS_LABELS,
//   JOB_TYPE_LABELS,
//   downloadJobFile,
// } from "@/lib/reportJobs";
// import { USER_ID } from "@/constants/constant";

// const STATUS_STYLES = {
//   queued: "bg-muted text-muted-foreground",
//   processing: "bg-blue-50 text-blue-600",
//   done: "bg-green-50 text-green-700",
//   failed: "bg-red-50 text-red-600",
//   cancelled: "bg-muted text-muted-foreground",
// };

// const StatusIcon = ({ status }) => {
//   if (status === "processing") return <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />;
//   if (status === "done") return <CheckCircle2 className="w-4 h-4 text-green-600" />;
//   if (status === "failed") return <XCircle className="w-4 h-4 text-red-600" />;
//   return <Clock className="w-4 h-4 text-muted-foreground" />;
// };

// // Shimmer placeholder shown while the first API call is in flight
// const SkeletonRow = () => (
//   <div className="flex flex-wrap items-center gap-3 px-4 py-3">
//     {/* <Skeleton className="w-4 h-4 rounded-full" /> */}
//     <div className="flex-1 min-w-[200px] space-y-2">
//       <Skeleton className="h-4 w-3/4" />
//       <Skeleton className="h-4 w-3/4" />
//     </div>
//     <Skeleton className="h-6 w-14 rounded-md" />
//     <Skeleton className="h-6 w-14 rounded-md" />
//   </div>
// );

// const formatWhen = (iso) => {
//   if (!iso) return "";
//   const date = new Date(iso);
//   return Number.isNaN(date.getTime()) ? iso : date.toLocaleString();
// };

// const statusLabel = (job) => {
//   if (job.status === "processing") return `Generating ${job.progress || 0}%`;
//   if (job.status !== "done") return JOB_STATUS_LABELS[job.status] || job.status;
//   if (job.job_type !== "export") return "Finalized";
//   return job.has_pdf || job.has_pptx ? "Ready to download" : "Replaced";
// };

// const FinalizeRequestsPanel = ({
//   onJobFinished,
//   title = "Finalize & export requests",
//   emptyText = null, // shown instead of hiding the panel when there are no requests
//   className = "mb-6",
// }) => {
//   const { jobs, loaded, reload } = useRecentJobs();
//   const [cancellingId, setCancellingId] = useState(null);
//   const [downloading, setDownloading] = useState(null);
//   const statusRef = useRef({});
//   const onJobFinishedRef = useRef(onJobFinished);
//   useEffect(() => {
//     onJobFinishedRef.current = onJobFinished;
//   }, [onJobFinished]);

//   // A request that just finished means a new file in the lists around us
//   useEffect(() => {
//     const justFinished = jobs.some(
//       (job) =>
//         FINISHED_STATUSES.includes(job.status) &&
//         statusRef.current[job.id] &&
//         !FINISHED_STATUSES.includes(statusRef.current[job.id])
//     );
//     jobs.forEach((job) => {
//       statusRef.current[job.id] = job.status;
//     });
//     if (justFinished) onJobFinishedRef.current?.();
//   }, [jobs]);

//   const cancel = async (id) => {
//     setCancellingId(id);
//     try {
//       await apiCall("post", "/reports/jobs/cancel", { id });
//       await reload();
//     } catch {
//       /* toast already shown */
//     } finally {
//       setCancellingId(null);
//     }
//   };

//   const download = async (job, type) => {
//     setDownloading(`${job.id}-${type}`);
//     try {
//       await downloadJobFile(job, type);
//     } catch {
//       toast.error("Download failed — please export again");
//     } finally {
//       setDownloading(null);
//     }
//   };

//   // Only true during the very first fetch. Polling reloads keep `loaded` = true,
//   // so the shimmer never comes back while the list silently refreshes.
//   const isLoading = !loaded && jobs.length === 0;

//   if (!isLoading && jobs.length === 0) {
//     if (!emptyText) return null;
//     return <p className="text-sm text-muted-foreground py-6 text-center">{emptyText}</p>;
//   }

//   const myId = USER_ID();

//   return (
//     <div className={`${className} rounded-xl border border-border bg-background`}>
//       <div className="px-4 py-3 border-b">
//         <h2 className="text-sm font-medium text-foreground">{title}</h2>
//         <p className="text-xs text-muted-foreground mt-0.5">
//           Board packs are generated on the server — you can close this page while they run.
//         </p>
//       </div>

//       <div className="divide-y">
//         {isLoading
//           ? Array.from({ length: 10 }).map((_, i) => <SkeletonRow key={i} />)
//           : jobs.map((job) => {
//               const isOwner =
//                 myId != null &&
//                 job.requested_by != null &&
//                 String(job.requested_by) === String(myId);
//               const canCancel =
//                 isOwner && (job.status === "queued" || job.status === "processing");

//               return (
//                 <div key={job.id} className="flex flex-wrap items-center gap-3 px-4 py-3">
//                   <StatusIcon status={job.status} />
//                   <div className="flex-1 min-w-[200px]">
//                     <p className="text-sm font-medium text-foreground truncate">
//                       <span className="text-muted-foreground font-normal">
//                         {JOB_TYPE_LABELS[job.job_type] || "Finalize"} ·{" "}
//                       </span>
//                       {job.contract} — {job.month} {job.year}
//                     </p>
//                     <p className="text-xs text-muted-foreground truncate">
//                       {job.requested_by_name ? `${job.requested_by_name} · ` : ""}
//                       {formatWhen(job.created_at)}
//                       {job.status === "failed" && job.message ? ` · ${job.message}` : ""}
//                       {job.status === "processing" && job.message ? ` · ${job.message}` : ""}
//                     </p>
//                     {job.status === "processing" && (
//                       <Progress value={job.progress || 0} className="h-1.5 mt-2 max-w-sm" />
//                     )}
//                   </div>
//                   <span
//                     className={`text-xs font-medium px-2 py-0.5 rounded-full ${STATUS_STYLES[job.status] || ""}`}
//                   >
//                     {statusLabel(job)}
//                   </span>

//                   {job.job_type === "export" &&
//                     job.status === "done" &&
//                     [
//                       ["pdf", "PDF", job.has_pdf],
//                       ["pptx", "PPTX", job.has_pptx],
//                     ]
//                       .filter(([, , available]) => available)
//                       .map(([type, label]) => (
//                         <Button
//                           key={type}
//                           variant="outline"
//                           size="sm"
//                           disabled={downloading === `${job.id}-${type}`}
//                           onClick={() => download(job, type)}
//                         >
//                           {downloading === `${job.id}-${type}` ? (
//                             <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" />
//                           ) : (
//                             <Download className="w-3.5 h-3.5 mr-1.5" />
//                           )}
//                           {label}
//                         </Button>
//                       ))}

//                   {canCancel && (
//                     <Button
//                       variant="outline"
//                       size="sm"
//                       disabled={cancellingId === job.id}
//                       onClick={() => cancel(job.id)}
//                     >
//                       Cancel
//                     </Button>
//                   )}
//                 </div>
//               );
//             })}
//       </div>
//     </div>
//   );
// };

// export default FinalizeRequestsPanel;

// src/components/BoardPack/FinalizeRequestsPanel.jsx
// Recent background finalize / export requests, latest one per board pack
// (Finalized BoardPacks page, Board Pack page without filters, Requests
// dialog). Polls while any request is still queued or generating; ready
// exports can be downloaded from here.
import { useEffect, useRef, useState } from "react";
import { CheckCircle2, Clock, Download, Loader2, XCircle } from "lucide-react";
import { apiCall } from "@/api/apiCall";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { Skeleton } from "@/components/ui/skeleton";
import { toast } from "sonner";
import { useRecentJobs } from "@/hooks/useRecentJobs";
import { useActiveDownloads } from "@/hooks/useActiveDownloads";
import {
  FINISHED_STATUSES,
  JOB_STATUS_LABELS,
  JOB_TYPE_LABELS,
  downloadJobFile,
  downloadKey,
} from "@/lib/reportJobs";
import { USER_ID } from "@/constants/constant";

const STATUS_STYLES = {
  queued: "bg-muted text-muted-foreground",
  processing: "bg-blue-50 text-blue-600",
  done: "bg-green-50 text-green-700",
  failed: "bg-red-50 text-red-600",
  cancelled: "bg-muted text-muted-foreground",
};

const StatusIcon = ({ status }) => {
  if (status === "processing") return <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />;
  if (status === "done") return <CheckCircle2 className="w-4 h-4 text-green-600" />;
  if (status === "failed") return <XCircle className="w-4 h-4 text-red-600" />;
  return <Clock className="w-4 h-4 text-muted-foreground" />;
};

// Shimmer placeholder shown while the first API call is in flight
const SkeletonRow = () => (
  <div className="flex flex-wrap items-center gap-3 px-4 py-3">
    <div className="flex-1 min-w-[200px] space-y-2">
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-3/4" />
    </div>
    <Skeleton className="h-6 w-14 rounded-md" />
    <Skeleton className="h-6 w-14 rounded-md" />
  </div>
);

const formatWhen = (iso) => {
  if (!iso) return "";
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? iso : date.toLocaleString();
};

const statusLabel = (job) => {
  if (job.status === "processing") return `Generating ${job.progress || 0}%`;
  if (job.status !== "done") return JOB_STATUS_LABELS[job.status] || job.status;
  if (job.job_type !== "export") return "Finalized";
  return job.has_pdf || job.has_pptx ? "Ready to download" : "Replaced";
};

const FinalizeRequestsPanel = ({
  onJobFinished,
  title = "Finalize & export requests",
  emptyText = null, // shown instead of hiding the panel when there are no requests
  className = "mb-6",
  listClassName = "", // extra classes for the rows container (e.g. make only the list scroll)
}) => {
  const { jobs, loaded, reload } = useRecentJobs();
  const [cancellingId, setCancellingId] = useState(null);
  // Shared store, so in-flight downloads survive the dialog closing
  const downloading = useActiveDownloads();
  const statusRef = useRef({});
  const onJobFinishedRef = useRef(onJobFinished);
  useEffect(() => {
    onJobFinishedRef.current = onJobFinished;
  }, [onJobFinished]);

  // A request that just finished means a new file in the lists around us
  useEffect(() => {
    const justFinished = jobs.some(
      (job) =>
        FINISHED_STATUSES.includes(job.status) &&
        statusRef.current[job.id] &&
        !FINISHED_STATUSES.includes(statusRef.current[job.id])
    );
    jobs.forEach((job) => {
      statusRef.current[job.id] = job.status;
    });
    if (justFinished) onJobFinishedRef.current?.();
  }, [jobs]);

  const cancel = async (id) => {
    setCancellingId(id);
    try {
      await apiCall("post", "/reports/jobs/cancel", { id });
      await reload();
    } catch {
      /* toast already shown */
    } finally {
      setCancellingId(null);
    }
  };

  const download = async (job, type) => {
    try {
      await downloadJobFile(job, type);
    } catch {
      toast.error("Download failed — please export again");
    }
  };

  // Only true during the very first fetch. Polling reloads keep `loaded` = true,
  // so the shimmer never comes back while the list silently refreshes.
  const isLoading = !loaded && jobs.length === 0;

  if (!isLoading && jobs.length === 0) {
    if (!emptyText) return null;
    return <p className="text-sm text-muted-foreground py-6 text-center">{emptyText}</p>;
  }

  const myId = USER_ID();

  return (
    <div className={`${className} rounded-xl border border-border bg-background overflow-hidden`}>
      <div className="px-4 py-3 border-b shrink-0">
        <h2 className="text-sm font-medium text-foreground">{title}</h2>
        <p className="text-xs text-muted-foreground mt-0.5">
          Board packs are generated on the server — you can close this page while they run.
        </p>
      </div>

      <div className={`divide-y ${listClassName}`}>
        {isLoading
          ? Array.from({ length: 10 }).map((_, i) => <SkeletonRow key={i} />)
          : jobs.map((job) => {
              const isOwner =
                myId != null &&
                job.requested_by != null &&
                String(job.requested_by) === String(myId);
              const canCancel =
                isOwner && (job.status === "queued" || job.status === "processing");

              return (
                <div key={job.id} className="flex flex-wrap items-center gap-3 px-4 py-3">
                  {/* <StatusIcon status={job.status} /> */}
                  <div className="flex-1 min-w-[200px]">
                    {/* Row 1: poora contract name (truncate nahi hoga) */}
                    <p className="text-sm font-medium text-foreground break-words">
                      <span className="text-muted-foreground font-normal">
                        {JOB_TYPE_LABELS[job.job_type] || "Finalize"} ·{" "}
                      </span>
                      {job.contract}
                    </p>
                    {/* Row 2: Month & year alag se highlighted */}
                    <span className="inline-block mt-1 text-xs font-semibold px-2 py-0.5 rounded-md bg-primary/10 text-primary border border-primary/20 whitespace-nowrap">
                      {job.month} - {job.year}
                    </span>

                    {/* Row 3: user, time aur message (sirf ek dafa) */}
                    <p className="text-xs text-muted-foreground mt-1 break-words">
                      {job.requested_by_name ? `${job.requested_by_name} · ` : ""}
                      {formatWhen(job.created_at)}
                      {job.status === "failed" && job.message ? ` · ${job.message}` : ""}
                      {job.status === "processing" && job.message ? ` · ${job.message}` : ""}
                    </p>
                    {job.status === "processing" && (
                      <Progress value={job.progress || 0} className="h-1.5 mt-2 max-w-sm" />
                    )}
                  </div>
                  <span
                    className={`text-xs font-medium px-2 py-0.5 rounded-full ${STATUS_STYLES[job.status] || ""}`}
                  >
                    {statusLabel(job)}
                  </span>

                  {job.job_type === "export" &&
                    job.status === "done" &&
                    [
                      ["pdf", "PDF", job.has_pdf],
                      ["pptx", "PPTX", job.has_pptx],
                    ]
                      .filter(([, , available]) => available)
                      .map(([type, label]) => (
                        <Button
                          key={type}
                          variant="outline"
                          size="sm"
                          disabled={downloading.has(downloadKey(job, type))}
                          onClick={() => download(job, type)}
                        >
                          {downloading.has(downloadKey(job, type)) ? (
                            <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" />
                          ) : (
                            <Download className="w-3.5 h-3.5 mr-1.5" />
                          )}
                          {label}
                        </Button>
                      ))}

                  {canCancel && (
                    <Button
                      variant="outline"
                      size="sm"
                      disabled={cancellingId === job.id}
                      onClick={() => cancel(job.id)}
                    >
                      Cancel
                    </Button>
                  )}
                </div>
              );
            })}
      </div>
    </div>
  );
};

export default FinalizeRequestsPanel;